import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ProjectCompletionService } from '../../../../../shared/API-Service/services/project-completion.service';
import Swal from 'sweetalert2';
import {BaseComponent } from '../../../../../../app/shared/components/base/base.component'
@Component({
  selector: 'app-list-project-accomplishment',
  templateUrl: './list-project-accomplishment.component.html',
  styleUrls: ['./list-project-accomplishment.component.css']
})
export class ListProjectAccomplishmentComponent extends BaseComponent implements OnInit {
  ProjectsCompletion: any;
  Projectid: string;

  constructor(private route: ActivatedRoute,private ProjectCompletionService:ProjectCompletionService,private _Router:Router) { super()}

  
  ngOnInit(): void {
    if (this.route.snapshot.paramMap.get("id")) {
      console.log(this.route.snapshot.paramMap.get("id"))
      this.Projectid =this.route.snapshot.paramMap.get("id")
      this.getProjectAccomplishment(this.Projectid);

    } 
  }
  GoToNew(){
    this._Router.navigate(['/content/admin/insert-projectcompletion',this.Projectid]);
  }
  // pageChanged(event: any){
  //   this.pageNumber = event.page;// -1 * pageSize;
  //   this.pager.skipCount = (this.pageNumber - 1) * this.pager.maxResultCount;
  //   this.ProjectCompletionService.GetProjectCompletion(this.pager).subscribe((res) => {
  //     this.ProjectsCompletion = res.data.items
  //     this.totalCount=res.data.totalCount;
  //   console.log(this.ProjectsCompletion);
    
  //   },(err)=>{
  //     console.log('their is a problem');
  //   },() =>{
  //     console.log('Completed');
  //   });

  // }
  getProjectAccomplishment(ProjectId){
    // const data={
    //   "maxResultCount": this.pager.maxResultCount,
    //   "skipCount": this.pager.skipCount,
    // }
    this.ProjectCompletionService.GetProjectCompletion(ProjectId).subscribe((res) => {
      this.ProjectsCompletion = res.data
//this.totalCount=res.data.totalCount;
    console.log(this.ProjectsCompletion);
    
    },(err)=>{
      console.log('their is a problem');
    },() =>{
      console.log('Completed');
    });
  }
  update(id){
    console.log(id);
    //this.PartnersService.Data.next(data);
    // this._Router.navigate(['/content/admin/insert-partner']);
    this._Router.navigate(['/content/admin/update-projectcompletion',this.Projectid,id]);
    }

    delete(id : number){
      Swal.fire({
        title: 'هل تريد مسح العنصر ؟',
        text: "لن يكون لك صلاحية إعادته مره اخرى",
        icon: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: 'الغاء',
        confirmButtonText: 'امسح العنصر !'
      }).then((result) => {
        if (result.isConfirmed) {
          this.ProjectCompletionService.DeleteProjectCompletion(id).subscribe((res) => {
            Swal.fire({
              icon: "success",
              title: "تم المسح بنجاح",
              showConfirmButton: false,
              timer: 1500,
            });
         this.getProjectAccomplishment(this.Projectid);
          },(err) => {
            Swal.fire({
              icon: 'error',
              title: 'خطأ',
              text:err.error.message    
            })
          },() => {
            console.log("completed");
          })
        }
      }) 
    }


}
